import { HTTP } from '@/utils/http';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

const getters = {
  [getterTypes.GET_ORDER]: state => state.order,
};

const actions = {
  async [actionTypes.DO_CREATE_ORDER]({ commit }, payload) {
    const { data } = await HTTP.post('/orders', payload);
    commit(mutationTypes.SET_ORDER, data.data.orders[0]);
    return data;
  },
};

const mutations = {
  [mutationTypes.SET_ORDER](state, order) {
    state.order = order;
  },
};

export default {
  state: {
    order: {},
  },
  getters,
  actions,
  mutations,
};
